/*
  Chilly · Envíos por código postal
  Muestra cuándo llega y cuánto sale el envío en la ficha de producto y en el carrito.
  Archivo propio de Chilly: no forma parte del tema original.

  Los precios, la hora de corte, los días de despacho y los feriados NO se tocan acá:
  se cargan en Contenido > Metaobjetos > Configuración de envíos.
  Las tablas de códigos postales están en assets/chilly-envios-datos.js.
*/
const TZ = 'America/Argentina/Buenos_Aires';
const CLAVE = 'chilly_cp';
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const DIA_MS = 86400000;
/* Costo estimado del envío estándar si falta el dato en el metaobjeto: por zona, [menos de 1 kg, de 1 a 2 kg, 2 kg o más] */
const ESTIMADO = [
  [11700, 12700, 16100],
  [16300, 17500, 20400],
  [16300, 17500, 20400],
  [18500, 20700, 25500],
];

/** @type {number[][]} */
let tablaF;
/** @type {number[][]} */
let tablaS;
/** @type {string[]} */
let nombres;
/** @type {string[]} */
let desde;

function cargar() {
  if (tablaF) return;
  /** @type {any} */
  const w = window;
  const datos = w.ChillyEnviosDatos || {};
  tablaF = armar(datos.F);
  tablaS = armar(datos.S);
  nombres = String(datos.N || '').split('|');
  desde = String(datos.DESDE || '').split(',');
}

/** @param {string} [txt] */
function armar(txt) {
  if (!txt) return [];
  return txt.split(';').map((x) => {
    const [r, v] = x.split(':');
    const [a, b] = r.split('-');
    const [p, q] = v.split(',');
    return [+a, +(b || a), +p, +q];
  });
}

/**
 * @param {number[][]} tabla
 * @param {number} cp
 */
function buscar(tabla, cp) {
  let lo = 0;
  let hi = tabla.length - 1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const fila = tabla[mid];
    if (cp < fila[0]) hi = mid - 1;
    else if (cp > fila[1]) lo = mid + 1;
    else return fila;
  }
  return null;
}

/** Fecha y hora de Buenos Aires, sin depender del huso del navegador */
function ahora() {
  /** @type {any} */
  const w = window;
  const prueba = typeof w.__chillyAhora === 'string' ? /(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(w.__chillyAhora) : null;
  if (prueba) {
    return { dia: new Date(Date.UTC(+prueba[1], +prueba[2] - 1, +prueba[3])), h: +prueba[4], m: +prueba[5] };
  }
  /** @type {Record<string, string>} */
  const p = {};
  try {
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach((x) => (p[x.type] = x.value));
    return { dia: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), h: +p.hour % 24, m: +p.minute };
  } catch (e) {
    /* Navegador sin soporte de husos: Argentina es UTC-3 todo el año */
    const d = new Date(Date.now() - 3 * 3600000);
    return {
      dia: new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())),
      h: d.getUTCHours(),
      m: d.getUTCMinutes(),
    };
  }
}

/** @param {Date} d @param {number} n */
const mas = (d, n) => new Date(d.getTime() + n * DIA_MS);
/** @param {Date} d */
const clave = (d) => d.getUTCDate() + '/' + (d.getUTCMonth() + 1) + '/' + d.getUTCFullYear();
/** @param {Date} d */
const corto = (d) => DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + '/' + (d.getUTCMonth() + 1);
/** @param {number} n */
const plata = (n) => '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
/** @param {string} t */
const esc = (t) =>
  String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] || c));

function leerCP() {
  try {
    return (localStorage.getItem(CLAVE) || '').replace(/\D/g, '').slice(0, 4);
  } catch (e) {
    return '';
  }
}

/** @param {string} cp */
function guardarCP(cp) {
  try {
    if (cp) localStorage.setItem(CLAVE, cp);
    else localStorage.removeItem(CLAVE);
  } catch (e) {
    /* sin almacenamiento: el código postal vive solo en esta página */
  }
}

let cpActual = leerCP();

/**
 * Costo real del envío estándar para el carrito actual, pedido a la tienda (el mismo que cobra el checkout).
 * @type {Map<string, {estado: string, precio?: number, suc?: boolean}>}
 */
const tarifas = new Map();

/**
 * @param {string} clave
 * @param {string} cp
 */
function pedirTarifa(clave, cp) {
  tarifas.set(clave, { estado: 'pidiendo' });
  /** @type {any} */
  const w = window;
  const raiz = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  /* La tienda exige una provincia, pero el costo sale del código postal */
  const provincia = +cp < 1500 ? 'Ciudad Autónoma de Buenos Aires' : 'Buenos Aires';
  const consulta =
    'shipping_address%5Bzip%5D=' +
    cp +
    '&shipping_address%5Bcountry%5D=Argentina&shipping_address%5Bprovince%5D=' +
    encodeURIComponent(provincia);
  /** @param {any} x */
  const esSucursal = (x) => /retiro|sucursal/i.test(x.name || '');
  /* Si la tienda tarda más de 12 segundos, se muestra el costo estimado */
  const corte = new AbortController();
  window.setTimeout(() => corte.abort(), 12000);
  fetch(raiz + 'cart/shipping_rates.json?' + consulta, { headers: { Accept: 'application/json' }, signal: corte.signal })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
    .then((j) => {
      /* Las tarifas de la app del correo traen su nombre en "source"; las propias de la tienda dicen "shopify" */
      const lista = ((j && j.shipping_rates) || []).filter((/** @type {any} */ x) => x.source && x.source !== 'shopify');
      const domicilio = lista.find((/** @type {any} */ x) => !esSucursal(x)) || lista[0];
      const precio = domicilio ? Math.round(parseFloat(domicilio.price)) : 0;
      tarifas.set(clave, precio > 0 ? { estado: 'ok', precio, suc: lista.some(esSucursal) } : { estado: 'error' });
    })
    .catch(() => {
      tarifas.set(clave, { estado: 'error' });
    })
    .then(() => window.dispatchEvent(new CustomEvent('chilly:cp')));
}

class ChillyEnvio extends HTMLElement {
  static observedAttributes = ['data-amount', 'data-peso', 'data-retiro', 'data-con-cp', 'data-abierto'];

  #editando = false;
  /* En la ficha el bloque es una fila que se abre y se cierra, como las del acordeón. Arranca cerrada */
  #abierto = false;
  #visto = false;
  /** @type {IntersectionObserver | undefined} */
  #io;
  /** @type {number | undefined} */
  #reloj;
  /** @type {AbortController | undefined} */
  #abort;
  /** @type {MutationObserver | undefined} */
  #obs;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.addEventListener('click', this.#alClic, { signal });
    this.addEventListener('keydown', this.#alTeclear, { signal });
    this.addEventListener('input', this.#alEscribir, { signal });
    window.addEventListener('chilly:cp', this.#pintar, { signal });
    document.addEventListener('variant:update', this.#alCambiarVariante, { signal });
    document.addEventListener('cart:update', this.#pintarLuego, { signal });
    document.addEventListener('visibilitychange', this.#pintar, { signal });

    /* Si el tema vuelve a dibujar el carrito y vacía el resultado, lo reponemos */
    this.#obs = new MutationObserver(() => {
      const res = this.querySelector('[data-res]');
      if (cpActual && res && !res.querySelector('[data-listo]')) this.#pintar();
    });
    this.#obs.observe(this, { childList: true, subtree: true });

    /* En el carrito, el costo real se pide recién cuando el bloque se ve en pantalla */
    if (this.dataset.contexto !== 'ficha' && 'IntersectionObserver' in window) {
      this.#io = new IntersectionObserver((entradas) => {
        if (!entradas.some((x) => x.isIntersecting)) return;
        this.#visto = true;
        this.#io?.disconnect();
        this.#pintar();
      });
      this.#io.observe(this);
    } else {
      this.#visto = true;
    }

    this.#reloj = window.setInterval(this.#pintar, 60000);
    this.#pintar();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#obs?.disconnect();
    this.#io?.disconnect();
    window.clearInterval(this.#reloj);
  }

  attributeChangedCallback() {
    if (this.isConnected) this.#pintar();
  }

  get #cfg() {
    const d = this.dataset;
    const precios = (d.precios || '').split(',').map((x) => parseInt(x, 10));
    const colecta = (d.colecta || '')
      .toLowerCase()
      .split(/[,;/]+/)
      .map((x) => DIAS.indexOf(x.trim().replace('miercoles', 'miércoles').replace('sabado', 'sábado')))
      .filter((x) => x > 0 && x < 6);
    const feriados = [];
    const re = /(\d{1,2})\/(\d{1,2})\/(\d{4})/g;
    let m;
    while ((m = re.exec(d.feriados || ''))) feriados.push(+m[1] + '/' + +m[2] + '/' + m[3]);
    const corte = parseInt(d.corte || '', 10);
    const zonas = (d.estandar || '').split('|');
    return {
      monto: parseInt(d.amount || '0', 10) / 100,
      peso: parseInt(d.peso || '0', 10) || 0,
      estandar: ESTIMADO.map((def, i) => {
        const v = (zonas[i] || '').split(',').map((x) => parseInt(x.replace(/\D/g, ''), 10));
        return def.map((n, j) => (v[j] >= 0 ? v[j] : n));
      }),
      umbral: parseInt(d.umbral || '0', 10) || 130000,
      corte: corte >= 0 && corte <= 23 ? corte : 11,
      ventana: d.ventana || '',
      precios: [4990, 6990, 8990, 10490].map((def, i) => (precios[i] > 0 ? precios[i] : def)),
      colecta: colecta.length ? colecta : [2, 5],
      feriados,
      nota: d.nota || '',
      retiro: d.retiro || '',
      retiroPlazo: d.retiroPlazo || '',
    };
  }

  /** @param {Event} e */
  #alClic = (e) => {
    const t = e.target instanceof Element ? e.target.closest('[data-calc],[data-cambiar],[data-abrir]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-abrir')) {
      this.#abierto = !this.#abierto;
      this.#pintar();
      return;
    }
    if (t.hasAttribute('data-cambiar')) {
      this.#editando = true;
      /* En la ficha, mientras se cambia el código postal queda solo el campo */
      const res = this.querySelector('[data-res]');
      if (res && this.dataset.contexto === 'ficha') res.innerHTML = '';
      this.#pintar();
      const inp = this.querySelector('input');
      if (inp) {
        inp.focus();
        inp.select();
      }
      return;
    }
    this.#calcular();
  };

  /* Si se borra el código postal del campo, todo vuelve a quedar como al principio */
  /** @param {Event} e */
  #alEscribir = (e) => {
    if (!(e.target instanceof HTMLInputElement)) return;
    if (e.target.value.replace(/\D/g, '') !== '' || !cpActual) return;
    this.#olvidar();
  };

  #olvidar() {
    cpActual = '';
    guardarCP('');
    this.#editando = false;
    window.dispatchEvent(new CustomEvent('chilly:cp'));
  }

  /** @param {KeyboardEvent} e */
  #alTeclear = (e) => {
    if (e.key !== 'Enter' || !(e.target instanceof HTMLInputElement)) return;
    e.preventDefault();
    this.#calcular();
  };

  #calcular() {
    const inp = this.querySelector('input');
    const m = /\d{4}/.exec(inp ? inp.value : '');
    const res = this.querySelector('[data-res]');
    if (!m && inp && inp.value.replace(/\D/g, '') === '' && cpActual) {
      this.#olvidar();
      return;
    }
    if (!m) {
      if (res) {
        res.innerHTML =
          '<p class="chilly-envio__aviso" data-listo>Ingresá los 4 números de tu código postal. Por ejemplo: 1642.</p>';
      }
      if (inp) inp.focus();
      return;
    }
    cpActual = m[0];
    guardarCP(cpActual);
    this.#editando = false;
    /* Recién calculado, la fila queda abierta para que se vean todas las opciones */
    this.#abierto = true;
    window.dispatchEvent(new CustomEvent('chilly:cp'));
  }

  /** @param {any} e */
  #alCambiarVariante = (e) => {
    if (this.dataset.contexto !== 'ficha') return;
    const datos = e.detail && e.detail.data;
    if (datos && datos.productId && this.dataset.productId && String(datos.productId) !== this.dataset.productId) return;
    const nuevo = datos && datos.html && datos.html.querySelector ? datos.html.querySelector('chilly-envio[data-contexto="ficha"]') : null;
    const precio = nuevo ? nuevo.getAttribute('data-amount') : e.detail && e.detail.resource && e.detail.resource.price;
    const peso = nuevo ? nuevo.getAttribute('data-peso') : null;
    if (peso != null && peso !== this.dataset.peso) this.dataset.peso = peso;
    if (nuevo) {
      this.dataset.retiroPlazo = nuevo.getAttribute('data-retiro-plazo') || '';
      const retiro = nuevo.getAttribute('data-retiro') || '';
      if (retiro !== (this.dataset.retiro || '')) this.dataset.retiro = retiro;
    }
    if (precio != null && String(precio) !== this.dataset.amount) this.dataset.amount = String(precio);
  };

  #pintarLuego = () => window.setTimeout(this.#pintar, 400);

  #pintar = () => {
    const res = this.querySelector('[data-res]');
    if (!res) return;
    const ficha = this.dataset.contexto === 'ficha';
    if (ficha) {
      this.toggleAttribute('data-abierto', this.#abierto);
      const boton = this.querySelector('[data-abrir]');
      if (boton) boton.setAttribute('aria-expanded', String(this.#abierto));
    }
    const cp = cpActual;
    const inp = this.querySelector('input');
    const conCP = !!cp && !this.#editando;
    this.toggleAttribute('data-con-cp', conCP);
    if (inp && cp && document.activeElement !== inp && inp.value !== cp) inp.value = cp;
    if (!cp || this.#editando) {
      if (ficha) this.#titular('');
      if (!cp && res.innerHTML !== '') res.innerHTML = '';
      if (!cp && inp && document.activeElement !== inp) inp.value = '';
      return;
    }
    const r = this.#resultado(cp);
    if (res.innerHTML !== r.html) res.innerHTML = r.html;
    if (ficha) this.#titular(r.titulo);
  };

  /**
   * Título de la fila en la ficha: siempre "Forma de entrega". Abajo, la mejor opción si hay código postal
   * ("Llega mañana · Estimado para CP: 1642", con el costo a la derecha) o la bajada fija ("Elegí cómo recibirlo…").
   * @param {string} html
   */
  #titular(html) {
    const t = this.querySelector('[data-titulo]');
    if (!t) return;
    const bajada = this.dataset.bajada;
    const nuevo =
      html ||
      '<span>' +
        esc(this.dataset.titulo || '') +
        '</span>' +
        (bajada ? '<span class="chilly-envio__detalle">' + esc(bajada) + '</span>' : '');
    if (t.innerHTML !== nuevo) t.innerHTML = nuevo;
  }

  /** @param {string} cp */
  #resultado(cp) {
    const c = this.#cfg;
    cargar();
    const n = +cp;
    const f = buscar(tablaF, n);
    const s = buscar(tablaS, n);
    const { dia, h, m } = ahora();
    /** @param {Date} d */
    const habil = (d) => d.getUTCDay() > 0 && d.getUTCDay() < 6 && !c.feriados.includes(clave(d));
    const gratis = c.monto >= c.umbral;
    const ficha = this.dataset.contexto === 'ficha';
    const lugar = f && nombres[f[3]] ? ' · ' + esc(nombres[f[3]]) : '';
    const para = '<strong>' + cp + lugar + '</strong>';
    const cambiar = '<button type="button" class="chilly-envio__cambiar" data-cambiar>Cambiar</button>';

    if (!f && !s) {
      return {
        titulo: '',
        html:
          '<p class="chilly-envio__donde" data-listo>Para ' +
          para +
          ' ' +
          cambiar +
          '</p><p class="chilly-envio__aviso">No encontramos ese código postal. El costo y el plazo los vas a ver al finalizar la compra.</p>',
      };
    }

    /**
     * Opciones de envío, la mejor primero.
     * nombre y detalles: lo que se ve en la lista. titular y corto: lo que se lee en la fila cerrada de la ficha.
     * (titular: "Llega mañana", "Llega alrededor del 21/10"; corto: el reloj de "Comprando dentro de…")
     * precio: cierre de la etiqueta del precio (clase + contenido).
     * @type {{nombre: string, detalles: string[], titular: string, corto: string, precio: string, retiro?: boolean}[]}
     */
    const ops = [];

    if (f) {
      let titulo;
      let reloj = '';
      const hoy = habil(dia) && h < c.corte;
      if (hoy) {
        titulo = 'Llega hoy';
        const min = (c.corte - h) * 60 - m;
        reloj =
          '<span class="chilly-envio__reloj">Comprando dentro de ' +
          (min >= 60 ? Math.floor(min / 60) + ' h' + (min % 60 ? ' ' + (min % 60) + ' min' : '') : min + ' min') +
          '</span>';
      } else {
        let d = mas(dia, 1);
        while (!habil(d)) d = mas(d, 1);
        titulo = d.getTime() === mas(dia, 1).getTime() ? 'Llega mañana' : 'Llega el ' + corto(d);
      }
      const detalles = [];
      if (reloj) detalles.push(reloj);
      if (c.ventana) detalles.push('Entrega ' + esc(c.ventana));
      if (hoy && c.nota) detalles.push(esc(c.nota));
      ops.push({
        nombre: titulo + ' <span class="chilly-envio__tag">Flex</span>',
        detalles,
        titular: titulo,
        corto: reloj,
        precio: gratis
          ? ' chilly-envio__precio--gratis">Gratis'
          : '">' + (desde.includes(cp) ? '<small>desde</small> ' : '') + plata(c.precios[f[2] - 1]),
      });
    }

    /* El estándar se muestra siempre: es la alternativa para quien no puede recibir en la franja del envío en el día */
    if (s) {
      let sale = mas(dia, 1);
      let tope = 0;
      while (!(c.colecta.includes(sale.getUTCDay()) && habil(sale)) && tope++ < 30) sale = mas(sale, 1);
      let llega = sale;
      let faltan = s[3];
      while (faltan > 0) {
        llega = mas(llega, 1);
        if (habil(llega)) faltan--;
      }
      /* Costo: gratis, real (carrito) o estimado por zona y peso (ficha) */
      const fila = c.estandar[s[2] - 1] || [];
      const estimado = fila[c.peso >= 2000 ? 2 : c.peso >= 1000 ? 1 : 0] || 0;
      let costo = estimado
        ? '"><small>aprox.</small> ' + plata(estimado)
        : ' chilly-envio__precio--despues">Se calcula al<br>finalizar la compra';
      let donde = 'A domicilio o a sucursal';
      if (gratis) {
        costo = ' chilly-envio__precio--gratis">Gratis';
      } else if (!ficha) {
        const llave = cp + '|' + this.dataset.amount + '|' + c.peso;
        const aLaVista = this.#visto || (!document.hidden && this.getClientRects().length > 0);
        if (!tarifas.has(llave) && aLaVista) pedirTarifa(llave, cp);
        const t = tarifas.get(llave);
        if (t && t.estado === 'ok') {
          costo = '">' + plata(t.precio || 0);
          if (!t.suc) donde = 'A domicilio';
        } else if (!t || t.estado === 'pidiendo') {
          costo = ' chilly-envio__precio--despues">Calculando…';
        }
      }
      ops.push({
        nombre: 'Envío estándar',
        detalles: [donde, 'Sale el ' + corto(sale) + ' · llega alrededor del ' + corto(llega)],
        titular: 'Llega alrededor del ' + llega.getUTCDate() + '/' + (llega.getUTCMonth() + 1),
        corto: '',
        precio: costo,
      });
    }

    /* Retiro en showroom: solo en la zona de envío en el día y si Shopify dice que la variante se puede retirar */
    if (f && c.retiro) {
      ops.push({
        nombre: 'Retiro en showroom',
        detalles: [esc(c.retiro)].concat(c.retiroPlazo ? [esc(c.retiroPlazo)] : []),
        titular: 'Retiro en showroom',
        corto: '',
        precio: ' chilly-envio__precio--gratis">Gratis',
        retiro: true,
      });
    }

    /** @param {string} t */
    const detalle = (t) => '<span class="chilly-envio__detalle">' + t + '</span>';
    const mejor = ops[0];
    /* Las opciones son informativas: ninguna va remarcada, para que no parezca que se eligen acá */
    const lista =
      '<ul class="chilly-envio__lista" role="list">' +
      ops
        .map(
          (o) =>
            '<li class="chilly-envio__opcion"' +
            (o.retiro ? ' data-fila-retiro' : '') +
            '><div class="chilly-envio__texto"><span class="chilly-envio__nombre">' +
            o.nombre +
            '</span>' +
            o.detalles.map(detalle).join('') +
            '</div><span class="chilly-envio__precio' +
            o.precio +
            '</span></li>'
        )
        .join('') +
      '</ul>';
    return {
      /* Fila cerrada de la ficha: la mejor opción, su costo y para qué código postal es */
      titulo:
        '<span class="chilly-envio__titular"><span>' +
        esc(this.dataset.titulo || '') +
        '</span><span class="chilly-envio__precio' +
        mejor.precio +
        '</span></span>' +
        detalle(mejor.titular + ' · Estimado para CP: <strong>' + cp + '</strong>') +
        (mejor.corto ? detalle(mejor.corto) : ''),
      html: ficha
        ? lista +
          '<p class="chilly-envio__aviso" data-listo>El costo final se calcula en el checkout, con tu dirección y los productos del carrito.</p>' +
          cambiar.replace('chilly-envio__cambiar"', 'chilly-envio__cambiar chilly-envio__cambiar--link"').replace('>Cambiar<', '>Cambiar código postal<')
        : '<p class="chilly-envio__donde" data-listo>Para ' + para + ' ' + cambiar + '</p>' + lista,
    };
  }
}

if (!customElements.get('chilly-envio')) {
  customElements.define('chilly-envio', ChillyEnvio);
}